import set from "lodash/set";
import { connect } from "react-redux";
import { storesReady } from "redux-store";
import { AUTH_GET_TOKEN_SUCCESS } from "redux-store/auth/actions";
import * as Auth from "redux-store/auth/selectors";
import { TokenLoginPage } from "view/auth/token-login";
import { getAppName } from "view/auth/utils";

function mapStateToProps(state) {
  const auth = Auth.authSelector(state);
  const storesLoaded = storesReady(state.global.auth);
  const isAuthenticated = Auth.isAuthenticated(auth);

  return {
    isAuthenticated,
    storesLoaded,
    title: getAppName(),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onLogin: (token) => {
      const payload = {};
      set(payload, "response.data.token", token);

      dispatch({
        payload,
        type: AUTH_GET_TOKEN_SUCCESS,
      });

      return Promise.resolve();
    },
  };
}

const ConnectedTokenLoginPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TokenLoginPage);

export { ConnectedTokenLoginPage };
